export default {
  name: 'listavatar',
  props: {
    listData: {
      type: Object,
      required: true
    }
  }
}
